module.exports = __webpack_public_path__ + "off_ramp_right.svg?509e8f309ad55a548e7de7cb8d1ba1bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/off_ramp_right.svg
// module id = 197
// module chunks = 0